module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// C:/Users/ondrej.siroky/Documents/frontend/~/core-js/library/modules/_add-to-unscopables.js
// module id = 51
// module chunks = 0 1